import React, { Component } from 'react'
import images from '../../ressources/images'
import { withTranslation } from 'react-i18next'
import {useSelector} from "react-redux";
import Cookies from "universal-cookie"

function NotConnected() {

    const style = {
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      maxWidth: "70%",
      height: "100vh",
      textAlign: "center"
    }

    const textStyle = {
      fontSize: "2rem"
    }

    const {t} = this.props

  const cookies = new Cookies();
  const theme = cookies.get('theme')

    return (
      <div style={style}>
        <img src={images['logo_' + theme]} alt=""/>
        <p style={textStyle}>{t('not_connected')}</p>
      </div>
    )
  }


export default withTranslation()(NotConnected)
